import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

const AddModal = ({
    show,
    onHide,
    workflowName,
    setWorkflowName,
    workflowList,
    setWorkflowList
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered  size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Add New Workflow</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className='gy-3'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Workflow Name <span className='text-danger'>*</span></Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={workflowName}
                                    onChange={(e) => setWorkflowName(e.target.value)}
                                    placeholder="Enter workflow name"
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Workflow List <span className='text-danger'>*</span></Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={6}
                                    value={workflowList}
                                    onChange={(e) => setWorkflowList(e.target.value)}
                                    placeholder=""
                                />
                                <Form.Text className="p-tag fs-12">
                                    Enter each workflow step on a new line
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onHide}>
                    Add Workflow
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddModal;
